<template>
  <div class="renewal">
    <div class="renewal__header">
      划拨用户：
      <!-- <SelectInput
        v-model="searchValue"
        style="margin-right:20px"
      /> -->
      <UserSelect
        v-model="searchValue"
        style="margin-right:20px"
      />
      划拨币数：
      <span>
        <el-input-number
          placeholder="划拨币数"
          v-model="coins"
          controls-position="right"
          :min="0"
          :max="999999"
          size="small"
          style="margin-right:20px;width: 120px"
        ></el-input-number>
      </span>
      <span style="margin-left: auto">
        <el-button
          style="margin-left: 32px"
          size="small"
          type="primary"
          @click="giveUserRecharge()"
        >划拨</el-button>
      </span>
    </div>
    <div class="renewal__content">
      <el-table
        :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)"
        border
        stripe
        height="100%"
        max-height="100%"
        style="min-width: 100%"
        size="mini"
        ref="table"
      >
        <el-table-column
          v-for="(item, index) in columns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.width"
          align="center"
          :fixed="item.fixed"
        />
        <!-- <el-table-column
          fixed="right"
          label="操作"
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="getIllegalDetail(scope.row)"
            >续费</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <!-- 表格结束 -->

      <!-- 分页开始 -->
      <el-pagination
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :page-sizes="[20, 50, 100]"
        layout="total,sizes, prev, pager, next, jumper"
        :total="total"
      />
      <!-- 分页结束 -->
    </div>
  </div>
</template>
<script>
import UserSelect from "@/components/UserSelect/index.vue";

export default {
  components: {
    UserSelect
  },
  props: {
    activeName: {
      type: String
    }
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 100,
      total: 0,
      tableData: [],
      searchValue: null,
      coins: 0,
      columns: [
        { prop: "index", label: "序号", width: 50, type: 0, fixed: false },
        { prop: "createTime", label: "时间", width: 80, type: 0, fixed: false },
        { prop: "money", label: "充值币数", width: 80, type: 0, fixed: false },
        {
          prop: "moneyAfter",
          label: "充值后币数",
          width: 100,
          type: 0,
          fixed: false
        },
        {
          prop: "moneyBefore",
          label: "充值前币数",
          width: 100,
          type: 0,
          fixed: false
        },
        { prop: "userA", label: "充值方", width: 150, type: 0, fixed: false },
        { prop: "userB", label: "接受充值方", width: 80, type: 0, fixed: false }
      ]
    };
  },
  mounted() {},

  computed: {},
  watch: {
    activeName: {
      handler() {
        this.$nextTick(() => {
          this.$refs.table.doLayout();
        });
      },
      deep: true
    }
  },
  methods: {
    async giveUserRecharge() {
      if (this.searchValue === "" || this.searchValue === null) {
        this.$msg({
          showClose: true,
          message: "请输入账户",
          type: "error"
        });
        return;
      }
      if (this.coins === 0) {
        this.$msg({
          showClose: true,
          message: "划拨币数不能为0",
          type: "error"
        });
        return;
      }
      try {
        const { data, msg } = await this.$API.giveUserRecharge({
          chargeNum: this.coins,
          userId: this.searchValue && this.searchValue.id
        });
        this.tableData = [data].map((item, index) => ({
          ...item,
          index: (this.currentPage - 1) * this.pageSize + index + 1
        }));
        this.$msg({
          showClose: true,
          message: msg,
          type: "success"
        });
        this.$emit("update");
      } catch (error) {
        console.log(error);
        this.$msg({
          showClose: true,
          message: error.msg,
          type: "error"
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.renewal {
  overflow: hidden;
  height: calc(100vh - 200px);
  display: flex;
  position: relative;
  &__header {
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    height: 40px;
    width: 100%;
    & > span {
      height: 40px;
      display: flex;
      align-items: center;
      white-space: nowrap;
      padding: 0 5px;
    }
    .btnOptions {
      .el-button + .el-button {
        margin-left: 1px;
      }
      .el-button:nth-child(1) {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }

      .el-button:nth-child(3) {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
  }
  &__content {
    width: 100%;
    position: absolute;
    top: 50px;
    height: calc(100vh - 300px);
    transition: all 0.2s;
  }
}
</style>